export async function selectDataSource(dataSources) {
  // update datasources and select dataSource with most data
  let dataSource;
  let totalItems = 0;
  for(let i = 0; i < dataSources.length; i++) {
    try {
      let d = await dataSources[i];
      await d.update(true);
      // console.log(d);
      if(d.size >= totalItems) {
        dataSource = d;
        totalItems = d.size;
      }
    } catch(err) {
      console.log("could not update", err);
    }
  }
  return dataSource;
}
export async function sparklineSummaryGenerator(chart, dataSource, columns) {
  chart.layout.grids = [];

  let parameters1 = {
    chartDataSource: {value: dataSource.id},
    groupData: {value: columns.group.field},
    itemData: {value: columns.date.field},
    transformItemData: {value: "dt(\"field\",'YYYY MM')"},
    valueData: {value: columns.value.field},
    transformValueData: {value: "sum(num(field))"},
  };

  let parameters2 = {
    chartDataSource: {value: dataSource.id},
    groupData: {value: columns.group.field},
    itemData: {value: columns.date.field},
    transformItemData: {value: "dt(\"field\",'YYYY MM')"},
    valueData: {value: columns.value.field},
    transformValueData: {value: "sum(num(field))"},
  };

  let parameters3 = {
    chartDataSource: {value: dataSource.id},
    groupData: {value: columns.list.field},
    itemData: {value: columns.date.field},
    transformItemData: {value: "dt(\"field\",'YYYY MM')"},
    valueData: {value: columns.value.field},
    transformValueData: {value: "sum(num(field))"},
  };
  // schema.chartDataSource

  // console.log("chart", chart);
  // create horizontal tp series
  const horizontalTopSeries = chart.addGrid({h: 7, w: 12});
  const aChart = chart.addGrid({h: 12, w: 12});
  const table = chart.addGrid({h: 15, w: 12});

  let horizontalTopSeriesLayer = horizontalTopSeries.layers[0];
  horizontalTopSeriesLayer.type = "sparkline.number";
  horizontalTopSeriesLayer.schema.parameters = parameters1;
  horizontalTopSeriesLayer.setTree(chart.getTree());
  horizontalTopSeriesLayer.loadParametersAndHydrator();
  horizontalTopSeriesLayer.hydrate();


  const aTypes = ["line.apexchart", "area.apexchart", "bar.apexchart"];
  let aChartLayer = aChart.layers[0];
  aChartLayer.type = aTypes[Math.floor(Math.random()*aTypes.length)];;
  aChartLayer.schema.parameters = parameters2;
  aChartLayer.setTree(chart.getTree());
  aChartLayer.loadParametersAndHydrator();
  aChartLayer.hydrate();


  let tableLayer = table.layers[0];
  tableLayer.type = "table";
  tableLayer.schema.parameters = parameters3;
  tableLayer.setTree(chart.getTree());
  tableLayer.loadParametersAndHydrator();
  tableLayer.hydrate();
  // console.log("layout.grids", chart.layout.grids);
  //await context.dispatch('aAddGrid', {h: 8, w: 6});
  //await context.dispatch('aAddGrid', {h: 8, w: 6});

  // grid.layout = state.chart.layout;

  // console.log("generator dataSources", dataSources);
}
